import { ALERT_TYPES } from './alert-types.enum';

export class Alert {
	type: ALERT_TYPES;
	message: string;

	constructor(type: ALERT_TYPES, message: string) {
		this.type = type;
		this.message = message;
	}
}
